import styled from 'styled-components';

export default styled.div`
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'collapse')};
`;
